import { underscore } from 'inflected';
import isObject from '~/utils/isObject';

const getValue = (value) => {
  if( isObject(value) && value.id ){ return value.id; }

  return value;
};

export default function(groups) {
  return groups.reduce((groups, group) => {
    const filtered = group.get('filters').reduce((filters, filter) => {
      const hasValue = (
        !!filter.get('column') &&
        !!filter.get('operation') &&
        (!!filter.get('value') || filter.get('value') === 0 || filter.get('value') === false)
      ) || filter.get('operation') === 'isBlank' || filter.get('operation') === 'isPresent';

      if (hasValue)
        filters.push({
          column: underscore(filter.get('column')),
          operation: filter.get('operation'),
          value: getValue(filter.get('value')),
        });

      return filters;
    }, []);

    if (filtered.length)
      groups.push({
        condition: group.get('condition'),
        filters: filtered,
      });

    return groups;
  }, []);
}
